/**
 * quantitySchedule Normalizr Schema
 */

import { schema } from 'normalizr';

import entity from './entity';
import event from './event';

const quantityForecast = new schema.Entity(
    'quantityForecasts',
    {
        entityId: entity,
        events: [event]
    },
    {
        idAttribute: value => value.entityId
    }
);

export default quantityForecast;
